import React from 'react';
import { SkillDetailVO } from '../services/aiAssistant';
import { Tooltip } from 'antd';

interface SkillChipBarProps {
  /** 本次会话启用的 skill id 列表（配置全集的子集） */
  enabledIds: number[];
  detailMap: Record<number, SkillDetailVO>;
  /** × 取消本次启用（不删除配置） */
  onToggleOff: (id: number) => void;
}

export default function SkillChipBar({ enabledIds, detailMap, onToggleOff }: SkillChipBarProps) {
  if (!enabledIds.length) return null;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginBottom: 6 }}>
      {enabledIds.map((id) => {
        const detail = detailMap[id];
        const offline = !detail;
        const label = detail?.title || detail?.name || `Skill #${id}`;
        const chip = (
          <div
            key={id}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              padding: '3px 7px',
              background: offline ? '#f5f5f7' : '#eef1f5',
              border: `1px solid ${offline ? '#e5e7eb' : '#dcdfe6'}`,
              borderRadius: 5,
              fontSize: 11,
              color: offline ? '#8c8c8c' : '#1d2129',
              maxWidth: 200
            }}
          >
            <svg viewBox="0 0 16 16" fill="none" width={10} height={10}>
              <path
                d="M10.5 1.8a3 3 0 0 0-3.7 3.7L1.8 10.5a1.4 1.4 0 0 0 2 2L8.8 7.5a3 3 0 0 0 3.7-3.7l-1.5 1.5-1.4-1.4z"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
            <span
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: 140
              }}
              title={offline ? undefined : label}
            >
              {label}
            </span>
            <span
              onClick={() => onToggleOff(id)}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#ff4d4f')}
              onMouseLeave={(e) => (e.currentTarget.style.color = '#8a94a6')}
              title="本次不使用"
              style={{
                fontSize: 13,
                lineHeight: 1,
                cursor: 'pointer',
                color: '#8a94a6',
                flexShrink: 0
              }}
            >
              ×
            </span>
          </div>
        );
        if (offline) {
          return (
            <Tooltip key={id} title="Skill 已下线">
              {chip}
            </Tooltip>
          );
        }
        return chip;
      })}
    </div>
  );
}
